import React from 'react';
import ReactPlayer from 'react-player';

const Scenario3Video2 = () => {
    return (
        <div className='Scenario1VideoWrap Scenario1Video3'>
            <ReactPlayer url='https://youtu.be/T4i0OnCcMNU' controls={true} />
        </div>
    );
}

export default Scenario3Video2;